const visitSurveyJson = (value: unknown, visit: (element: Record<string, unknown>) => void) => {
  if (Array.isArray(value)) {
    value.forEach((item) => visitSurveyJson(item, visit));
    return;
  }

  if (!value || typeof value !== 'object') {
    return;
  }

  const element = value as Record<string, unknown>;
  visit(element);
  Object.values(element).forEach((item) => visitSurveyJson(item, visit));
};

export const getSurveyFileCountLimits = (surveyJson: unknown) => {
  const limits = new Map<string, number>();

  visitSurveyJson(surveyJson, (element) => {
    if (element.type !== 'file' || typeof element.name !== 'string') {
      return;
    }

    const maxFiles = element.maxFiles;
    if (typeof maxFiles === 'number' && Number.isInteger(maxFiles) && maxFiles > 0) {
      limits.set(element.name, maxFiles);
    }
  });

  return limits;
};

export const getSurveyFileCount = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.length;
  }

  return value ? 1 : 0;
};

export const exceedsSurveyFileCountLimit = (currentCount: number, selectedCount: number, maxFiles?: number) =>
  maxFiles !== undefined && currentCount + selectedCount > maxFiles;

export const getSurveyFileCountLimitError = (maxFiles: number) =>
  `You can upload a maximum of ${maxFiles} file${maxFiles === 1 ? '' : 's'}.`;
